import { useState } from 'react';
import { Card, Divider, Stack, Typography } from '@mui/material';
import MuiGrid from '@mui/material/Grid';
import { PropTypes } from 'prop-types';
import { a, useTrail } from '@react-spring/web';
import BackButton from '../../components/BackButton';
import industries from '../../_mock/industries';

const Grid = (props) => (
  <MuiGrid
    item
    xs={4}
    {...props}
    sx={
      props.selected
        ? { borderBottom: '4px solid #FF2C04', cursor: 'pointer', p: 2 }
        : { borderBottom: '4px solid transparent', cursor: 'pointer', p: 2 }
    }
  />
);

Grid.propTypes = {
  selected: PropTypes.bool,
};

Grid.defaultProps = {
  selected: true,
};

const AllIndustries = () => {
  const trail = useTrail(industries.length, {
    config: { mass: 5, tension: 2000, friction: 200 },
    opacity: 1,
    x: 0,
    from: { opacity: 0, x: 20 },
  });

  return (
    <Stack direction="row" flexWrap="wrap">
      {trail.map(({ ...style }, index) => (
        <a.div style={style} key={index}>
          <Card sx={{ width: 240, mb: 2, p: 2, mr: 6 }}>
            <Typography textAlign="center">{industries[index]}</Typography>
          </Card>
        </a.div>
      ))}
    </Stack>
  );
};

export default function Websites() {
  const [selected, setSelected] = useState('purchased');

  const getContent = (e) => {
    switch (e) {
      case 'purchased':
        break;
      case 'all':
        break;
      case 'industry':
        return <AllIndustries />;
      default:
        return <></>;
    }
    return <></>;
  };

  return (
    <div
      style={{
        maxWidth: '90%',
        margin: 'auto',
      }}
    >
      <BackButton />
      <Typography variant="h3">Website</Typography>
      <Card sx={{ p: 2 }}>
        <MuiGrid container>
          <Grid onClick={() => setSelected('all')} selected={selected === 'all'}>
            <Typography textAlign="center" variant="h5">
              All Themes
            </Typography>
          </Grid>
          <Grid onClick={() => setSelected('purchased')} selected={selected === 'purchased'}>
            <Typography textAlign="center" variant="h5">
              Purchased
            </Typography>
          </Grid>
          <Grid onClick={() => setSelected('industry')} selected={selected === 'industry'}>
            <Typography textAlign="center" variant="h5">
              Choose Industry
            </Typography>
          </Grid>
        </MuiGrid>
        <Divider />
        <br />
        {getContent(selected)}
      </Card>
    </div>
  );
}
